import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';
import {GruposPaginas} from '../../configs/iluminação'

const LazerPagina = () => {
  return (
    <div className="lazer-container">
      <GroupLightComponent
        groupIds={GruposPaginas[1]}
        pageTitle="Luzes do lazer" 
      />
    </div>
  );
};

export default LazerPagina;